/**
 * This function is used to set up file upload functionality on a form. It is used
 * to set up the file upload UI.
 *
 * @param {Element} parent The parent element of the file upload inputs.
 */
function setupFileUpload (parent) {
  const fups = parent.querySelectorAll('input[type="file"].file-upload__file')

  for (const fup of fups) {
    init(fup, parent)
  }
}

// This function is used to initialize the form.
// It takes the fileUpload object and the form as arguments.
// The fileUpload object is used to upload files to the server.
// The form is used to submit the data.
const init = function (fileUpload, form) {
  const label = form.querySelector(`[data-file-for="${fileUpload.id}"]`)

  setLabel(fileUpload, label)

  fileUpload.addEventListener('input', function (e) {
    setLabel(fileUpload, label)
  })
}

// This function sets the label text of the fileUpload control to the value of the label parameter.
// The label parameter is of type String.
// The fileUpload parameter is an input [type="file"].
function setLabel (fileUpload, label) {
  // if there are more than 1 file selected, show the number of files selected
  if (fileUpload.files.length > 1) {
    label.innerHTML = `${fileUpload.files.length} files selected.`
  // if there is only 1 file selected, show the name of the file
  } else if (fileUpload.files.length > 0) {
    label.innerHTML = fileUpload.files[0].name
  // if there are no files selected, show the empty string
  } else {
    label.innerHTML = label.dataset.empty
  }

  if (fileUpload.files.length > 1) {
    label.innerHTML = `${fileUpload.files.length} files selected.`
  } else if (fileUpload.files.length > 0) {
    label.innerHTML = fileUpload.files[0].name
  } else {
    label.innerHTML = label.dataset.empty
  }
}

export {
  setupFileUpload
}
